import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import type { Observable } from 'rxjs';
import { ColorContext, SuggestionType } from '../shared/models';

export const suggestSkillMessage = `Don't see the skill you're looking for?`;
export const suggestSkillLinkText = 'Suggest a skill';

export const suggestIndustryMessage = `Don't see the industry you're looking for?`;
export const suggestIndustryLinkText = 'Suggest an industry';

const dialogConstants = {
    [SuggestionType.skill]: {
        guidelines:
            'Do not add personal attributes that cannot be tested or measured. Skills are ' +
            'defined as expertise in tools, subjects, methods or financial areas that require experience and some training.',
        acceptableItems: [
            'Email Automation',
            'HubSpot Sales',
            'Discounted Cash Flow (DCF) analysis',
        ],
        nonAcceptableItems: ['Management', 'Communications', 'Leadership'],
        name: 'Skill',
        label: 'Skill Name',
        placeholderText: 'e.g. Email Automation',
    },
    [SuggestionType.industry]: {
        guidelines:
            'Industries should be recognized business sectors that describe the ' +
            'category of companies and their economic activity.',
        acceptableItems: ['Asset Management', 'FinTech', 'E-Commerce'],
        nonAcceptableItems: ['Operations', 'Advisory', 'Computers'],
        name: 'Industry',
        label: 'Industry Name',
        placeholderText: 'e.g. Asset Management',
    },
    [SuggestionType.priority]: {
        guidelines:
            'Feel free to suggest workplace benefits, perks, and priorities that ' +
            'matter to you when evaluating a company or job.',
        acceptableItems: [
            'Dog-friendly office',
            'Extended maternity leave',
            '401k',
        ],
        nonAcceptableItems: [
            'Fun coworkers',
            'Ping pong tables',
            'Blue Bottle Coffee',
        ],
        name: 'Priority',
        label: 'Priority',
        placeholderText: 'e.g. Dog-friendly office',
    },
};

@Injectable()
export class AutocompleteSuggestionsService {
    static getAutocompleteSuggestionDialogConfig(
        type: SuggestionType,
        prefillValue = '',
    ) {
        return {
            title: `Suggest ${dialogConstants[type].name}`,
            colorContext: ColorContext.PRIMARY,
            titleAlign: 'left' as 'left' | 'center' | 'right',
            contentComponentData: {
                guidelines: dialogConstants[type].guidelines,
                acceptableItems: dialogConstants[type].acceptableItems,
                nonAcceptableItems: dialogConstants[type].nonAcceptableItems,
                inputFieldLabel: dialogConstants[type].label,
                inputFieldHint: `Enter only one ${dialogConstants[
                    type
                ].name.toLocaleLowerCase()} at a time`,
                inputFieldPlaceholder: dialogConstants[type].placeholderText,
                prefillValue,
                type,
            },
        };
    }

    constructor(private http: HttpClient) {}

    addSuggestion(suggestion: string, type: SuggestionType): Observable<void> {
        return this.http.post<void>('/api/autocomplete-suggestions', {
            suggestion,
            type,
        });
    }
}
